import { render } from "preact";
import { App } from "./App.js";
import { countClientErrors } from "./host/client-errors.js";
import { crashReportConfig, startCrashReports } from "./host/crash-reports.js";
import { appShell, shellTooOld } from "./host/shell.js";
import { entryOf, referrerBucket, track } from "./host/telemetry.js";
import { startPresence } from "./net/presence.js";
import { UpdateApp } from "./pages/UpdateApp.js";
import { applySettings } from "./settings/settings.js";
import "./styles.css";

// Every uncaught error counts in our own events (client_error, docs/metrics.md), Sentry or not.
countClientErrors(track);

// Crash reports (ADR 0012), in builds given a DSN. Errors are held from here on; the SDK loads after
// first paint.
const crashReports = crashReportConfig(import.meta.env);
if (crashReports) startCrashReports(crashReports, () => import("./host/sentry-sdk.js"));

// First load per tab (docs/metrics.md). The sandbox isn't a way in for players, so it's left out.
if (!location.pathname.startsWith("/play/"))
  track("app_opened", {
    entry: entryOf(location.pathname, location.hash, location.search),
    referrer_domain: referrerBucket(document.referrer, location.host),
  });

// Less motion and larger text follow the settings (P5-UX-07).
applySettings();

// An app shell older than this release supports is asked to update instead (P4-APP-08).
const shell = appShell(navigator.userAgent);
render(
  shell && shellTooOld(shell) ? <UpdateApp shell={shell} /> : <App />,
  document.getElementById("app") as HTMLElement,
);

// Friends see a signed-in person online (ADR 0031); guests send nothing.
if (!location.pathname.startsWith("/play/")) startPresence();
